import axios from "axios";
export default {


    state: {
        glossaryItems: []
    },
    mutations: {
        SET_GLOSSARY_ITEMS(state, payload) {
            state.glossaryItems = payload.glossaryItems
        },

    },
    getters: {
        getGlossaryItems: state => state.glossaryItems,
    },
    actions: {
        // Fetch glossary items from Strapi API using axios
        async fetchAllGlossaryItems(context, payload) {
            try {
                const response = await axios.get(`https://strapi.casimbagaming.com/api/${payload.link}`);
                return response;
            } catch (error) {
                console.log(error);
            }
        }
    }
}